import SectionHeading from '@/components/base/SectionHeading';
import { VOICES } from '@/mocks/schedule';

export default function Voices() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-secondary-950" aria-labelledby="voices-heading">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-accent-400 uppercase mb-3">
              <span className="w-6 h-px bg-accent-400" />
              Voices
            </span>
            <h2 id="voices-heading" className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
              选手和围观的人怎么说
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-300 leading-relaxed">
              以下是往届选手与关注赛事的朋友留下的反馈，关于时间表、提醒与进度透明度的真实感受。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {VOICES.map((v) => (
            <figure key={v.name} className="rounded-lg bg-secondary-900 border border-secondary-800 p-6 flex flex-col">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-double-quotes-l text-2xl text-accent-400"></i>
              </span>
              <blockquote className="mt-4 text-sm md:text-base text-background-100 leading-relaxed flex-1">
                {v.text}
              </blockquote>
              <figcaption className="mt-6 pt-4 border-t border-secondary-800">
                <div className="text-sm font-medium text-background-50">{v.name}</div>
                <div className="text-xs text-background-400 mt-1">{v.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}